export default {"src":"/_next/static/media/best-price-guarantee.5cb7b91a.svg","height":48,"width":181,"blurWidth":0,"blurHeight":0};